export const ctaForm: object = {
  ctaForm: {
    title: 'Your organization has already an existing solution',
    subTitle: 'Please choose from the options below:\n',
    buttonText: {
      ORDER_UPSELL: 'Expand existing contract',
      ORDER_NEW: 'Start a new contract',
      ORDER_NEW_ZERO_VALUE: 'Start a new contract',
      MANAGE_ORDERS: 'Manage Orders',
      CONTACT_SUPPORT: 'Need help?',
      ORDER_EXTENSION: 'Extend existing contract',
      ORDER_RESTRUCTURE_UPGRADE: 'Upgrade existing contract',
      TDD_ORDER_NEW: 'Start a new contract',
      TDD_ORDER_NEW_ZERO_VALUE: 'Start a new contract',
      TDD_UPSELL: 'Expand existing contract',
      TDD_EXTENSION: 'Extend existing contract',
      UPSELL_CONTACT_SALES_REP: 'Expand existing contract',
      EXTENSION_CONTACT_SUPPORT: 'Extend existing contract',
      UPSELL_CONTACT_SUPPORT: 'Expand existing contract',
      UPSELL_CONTACT_PARTNER: 'Expand existing contract',
    },
    subText: {
      ORDER_UPSELL: 'Increase licenses or credits for an existing contract.',
      ORDER_NEW: 'Start a new contract by placing an order on SAP Store.',
      ORDER_NEW_ZERO_VALUE: 'Start a new contract by placing an order on SAP Store.',
      MANAGE_ORDERS: 'Visit SAP for Me to view and manage your existing orders and contracts.',
      CONTACT_SUPPORT: 'Please contact our support team and we\'re happy to help.',
      ORDER_EXTENSION: 'Add new licenses and add-ons to an existing contract.',
      ORDER_RESTRUCTURE_UPGRADE: 'Upgrade an existing license to an edition with more capabilities.',
      TDD_ORDER_NEW: 'Start a new contract by placing an order on SAP Store.',
      TDD_ORDER_NEW_ZERO_VALUE: 'Start a new contract by placing an order on SAP Store.',
      TDD_UPSELL: 'Increase licenses or credits for an existing contract.',
      TDD_EXTENSION: 'Add new licenses and add-ons to an existing contract.',
      UPSELL_CONTACT_SALES_REP: 'Contact Sales to increase licenses or credits for an existing contract.',
      EXTENSION_CONTACT_SUPPORT: 'Contact SAP Store support if you want to add this solution to an existing contract.',
      UPSELL_CONTACT_SUPPORT: 'Contact Sales to increase licenses or credits for an existing contract.',
      UPSELL_CONTACT_PARTNER: 'Contact Sales to increase licenses or credits for an existing contract.',
    },
    linkSubText: {
      MANAGE_ORDERS: {
        beginning: 'Visit ',
        link: 'SAP for Me',
        ending: ' to view and manage your existing orders and contracts.'
      },
      CONTACT_SUPPORT: {
        beginning: 'Please ',
        link: 'contact our support team',
        ending: ' and we\'re happy to help.'
      }
    }
  }
};
